import { kebabCase } from 'shared/functions';

// TODO: Its mocked data until we decide to get it from backend
const checkBusinessLine = (businessLine, percent) => {
  switch (businessLine) {
    case 'Banks':
      return 49;
    case 'Corporates':
      return 40;
    case 'Sovereigns':
      return 100;
    case 'Sub-Sovereigns':
      return 69;
    case 'Supranationals':
      return 50;
    default:
      return percent;
  }
};

export const ratingCoveragePercentagesParser = data =>
  data
    .filter(v => v.percent > 0)
    .map(({ businessLine, rated, percent }) => ({
      label: businessLine,
      total: rated,
      percent: checkBusinessLine(businessLine, percent),
      id: kebabCase(businessLine),
    }));
